import { BigNumber } from "ethers"
import { renderAmount, toAmount } from "./helpers"

export function getFormattedValue(
	value?: string,
	decimals = 18,
	digits = 6
): string {
	if (!value) {
		return '0'
	}

	let formattedValue: string
	try {
		const amount = toAmount(decimals, BigNumber.from(value))
		formattedValue = `${renderAmount(amount, digits)}`
	} catch (error) {
		console.warn(error)
	}

	return formattedValue || '0'
}